import Badge from "@/components/common/Badge"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHouse, faQrcode, faInbox, faClipboardList } from "@fortawesome/free-solid-svg-icons"

const BottomNavigation = ({ onNavigate, onShowModal, pendingList = 0 }) => {
  const bottomItems = [
    {
      key: "home",
      label: "Home",
      icon: faHouse,
      onClick: () => onNavigate("/home"),
      isActive: true,
    },
    {
      key: "orders",
      label: "Orders",
      icon: faClipboardList,
      onClick: () => onNavigate("/help/history-ticket"),
    },
    {
      key: "scan",
      label: "Scan",
      icon: faQrcode,
      onClick: onShowModal,
    },
    {
      key: "inbox",
      label: "Inbox",
      icon: faInbox,
      onClick: () => onNavigate("/wf/pending"),
      badge: pendingList,
    },
  ]

  return (
    <div className="w-full bg-white border-t border-gray-100 shadow-[0_-5px_20px_rgba(0,0,0,0.02)]">
      <div className="max-w-[1320px] w-full mx-auto px-8 py-2 flex justify-between items-end">
        {bottomItems.map(item => (
          <div key={item.key} onClick={item.onClick} className={`flex flex-col items-center gap-1 cursor-pointer w-14 group ${item.key === "scan" ? "-mt-1" : ""}`}>
            {item.badge !== undefined ? (
              <Badge count={item.badge || 0}>
                <FontAwesomeIcon icon={item.icon} className={`text-xl mb-0.5 transition-colors ${item.isActive ? "text-primary-600" : "text-gray-400 group-hover:text-primary-600"}`} />
              </Badge>
            ) : (
              <FontAwesomeIcon icon={item.icon} className={`text-xl mb-0.5 transition-colors ${item.isActive ? "text-primary-600" : "text-gray-400 group-hover:text-primary-600"}`} />
            )}

            <span className={`text-[10px] transition-colors ${item.isActive ? "font-bold text-primary-600" : "font-medium text-gray-500 group-hover:text-primary-600"}`}>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
export default BottomNavigation
